import { defineMessages } from '@jutro/locale';

export default defineMessages({
    yourPolicy: {
        id: 'ml.account-management.wizardSidebar.yourXPolicy',
        defaultMessage: 'Your {policyType} Policy'
    },
    policyDetailsTitle: {
        id: 'ml.account-management.wizardSidebar.POLICY DETAILS',
        defaultMessage: 'POLICY DETAILS'
    },
    policyNumber: {
        id: 'ml.account-management.wizardSidebar.Policy #',
        defaultMessage: 'Policy #{policyNumber}'
    },
    effectiveDateOfChange: {
        id: 'ml.account-management.wizardSidebar.Effective date of change :',
        defaultMessage: 'Effective date of change : '
    },
    amountOfChange: {
        id: 'ml.account-management.wizardSidebar.Amount of change',
        defaultMessage: 'Amount of change : '
    },
    editEffectiveDate: {
        id: 'ml.account-management.wizardSidebar.Edit Effective Date',
        defaultMessage: 'Edit Effective Date'
    },
    changeProgressBar: {
        id: 'ml.account-management.wizardSidebar.CHANGE PROGRESS BAR',
        defaultMessage: 'CHANGE PROGRESS BAR'
    },
    discardAllChanges: {
        id: 'ml.account-management.wizardSidebar.DISCARD ALL CHANGES',
        defaultMessage: 'DISCARD ALL CHANGES'
    },
    withdrawingPolicyChange: {
        id: 'ml.account-management.wizardSidebar.Withdrawing Policy Change',
        defaultMessage: 'Withdrawing Policy Change'
    },
    confirmationTitle: {
        id: 'ml.account-management.wizardSidebar.Are you sure you want to cancel?',
        defaultMessage: 'Are you sure you want to cancel?'
    },
    confirmationDesc: {
        id: 'ml.account-management.wizardSidebar.Are you sure you want to cancel this policy change?',
        defaultMessage: 'Are you sure you want to cancel this policy change?'
    },
    yes: {
        id: 'ml.account-management.wizardSidebar.YES',
        defaultMessage: 'YES'
    },
    cancel: {
        id: 'ml.account-management.wizardSidebar.CANCEL',
        defaultMessage: 'CANCEL'
    },
    reviewYourCoverages:{
        id: 'ml.account-management.wizardSidebar.Review Your Coverages',
        defaultMessage: 'Review Your Coverages'
    },
    autoInsurance:{
        id: 'ml.account-management.wizardSidebar.AUTO INSURANCE',
        defaultMessage: 'AUTO INSURANCE'
    },
    umbrellaInsurance:{
        id: 'ml.account-management.wizardSidebar.UMBRELLA INSURANCE',
        defaultMessage: 'UMBRELLA INSURANCE'
    },
    month:{
        id: 'ml.account-management.wizardSidebar.Month',
        defaultMessage: 'Month'
    },
    previousCost:{
        id: 'ml.account-management.wizardSidebar.Previous Cost',
        defaultMessage: 'Previous Cost'
    },
    or:{
        id: 'ml.account-management.wizardSidebar.OR',
        defaultMessage: 'OR'
    },
    year:{
        id: 'ml.account-management.wizardSidebar.Year',
        defaultMessage: 'Year'
    },
    paymentMethod: {
        id: 'ml.account-management.wizardSidebar.Payment method:',
        defaultMessage: 'Payment method: '
    },
    paymentMethodEndingIn: {
        id: 'ml.account-management.wizardSidebar.Ending in',
        defaultMessage: 'Ending in {last4Digits}'
    },
    paymentSchedule: {
        id: 'ml.account-management.wizardSidebar.Payment schedule',
        defaultMessage: 'Payment schedule:'
    },
    insured: {
        id: 'ml.account-management.wizardSidebar.Insured',
        defaultMessage: 'Insured'
    },
    coInsured: {
        id: 'ml.account-management.wizardSidebar.Co-Insured',
        defaultMessage: 'Co-Insured'
    },
    makeAPayment: {
        id: 'ml.account-management.wizardSidebar.MAKE A PAYMENT',
        defaultMessage: 'MAKE A PAYMENT'
    },
    YourClaim: {
        id: 'ml.fnol.wizard.steps.Your Claim',
        defaultMessage: 'Your Claim'
    },
    StartAClaim: {
        id: 'ml.fnol.wizard.steps.Start a Claim',
        defaultMessage: 'Start a Claim'
    }
});